export const ExposeScrollbarWidth = ( function() {
	const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
	return {
		init() {
			// Expose scrollbar width as a CSS custom property.
			document.documentElement.style.setProperty( '--scrollbar--width', `${ scrollbarWidth }px` );
		},
	};
}() );
